















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class HisDetail extends Vue {
  @Prop()
  private message: any;
  @Prop()
  private link: any;
  private data: any = {};

  @Watch("message", { immediate: true })
  private messageChange(msg: any) {
    if (msg) {
      this.data = msg;
    }
  }
  private keys: any = ["主诉", "病情描述", "四诊摘要"];
  private returnList() {
    this.$emit("returnList");
  }
}
